export default "__VITE_ASSET__a496b0ae__"